import { Tooltip, OverlayTrigger } from "react-bootstrap";
const CustomToggle = ({ isToggled, setToggled, title, tooltip = "" }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={() => setToggled(!isToggled)}
      className={`notification-toggle align-items-center mr-16 mt-8 mb-8 ${
        isToggled ? "notification-on" : "notification-off"
      }`}
    >
      <div
        className={
          isToggled
            ? "notification-toggle-circle-on"
            : "notification-toggle-circle-off"
        }
      ></div>
    </button>

    <span className="fs-16 fw-500">{title}</span>

    {tooltip && (
      <OverlayTrigger
        placement="auto"
        overlay={
          <Tooltip className="v4-tooltip-tall fw-500">{tooltip}</Tooltip>
        }
      >
        <i className="ml-8 fs-18 fa-regular fa-circle-question"></i>
      </OverlayTrigger>
    )}
  </div>
);

export default CustomToggle;
